<div class="table-container">

    <apc-datatable-filters (displaySearchEvent)="displaySearch()" (clearSearchEvent)="clearSearch()"
        (exportCSVEvent)="exportCSV()" (copyToClipboardEvent)="copyToClipboard()" (exportSheetEvent)="exportSheet()"
        (refreshDataEvent)="refreshData()" (selectTableColumnsEvent)="addNewColumn($event);"
        (selectAllColumnsEvent)="selectAllColumns()" (defaultColumnsEvent)="defaultColumnsReset()"
        (unselectAllColumnsEvent)="unselectAllColumns()" [columnsToDisplayInDropdown]="columnsToDisplayInDropdown"
        (statusFilterEvent)="statusFilter($event)" [showSearch]="showSearch" [enableFilter]="enableFilter"
        [isAdministration]="isAdministration" [selectedTableColumns]="selectedTableColumns"
        (setToken)="setToken($event)">
    </apc-datatable-filters>

    <ngx-datatable [ngClass]="this.userWithOutPerm?'apc withoOutP':'apc'" [rows]="rows" [columnMode]="'force'"
        [footerHeight]="50" rowHeight="auto" [count]="page.totalElements"
        [offset]="page.pageNumber" [limit]="pageElements" (page)="setPage($event)" [sortType]="SortType.single"
        (sort)="onSort($event)" [externalSorting]="true" [columns]="selectedTableColumns" [externalPaging]="true"
        [sorts]="sortArray" #tableComponent>

        <ng-template #personNameCell let-row="row" let-value="value" let-column="column" let-i="index">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value}} </div>
        </ng-template>

        <ng-template #dateCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | date: 'dd/MM/yyyy'}} </div>
        </ng-template>

        <ng-template #percentageCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | percent: '1.0-2':'it' }} </div>
        </ng-template>

        <ng-template #timeCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{ (value !== '') ?
                (convertStringToDate(value) | date:'HH:mm') : "" }} </div>
        </ng-template>

        <ng-template #plainCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value}} </div>
        </ng-template>

        <ng-template #numberCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | number:'1.0-2': 'it'}} </div>
        </ng-template>

        <ng-template #currencyCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | number:'1.2-2': 'it'}} € </div>
        </ng-template>

        <ng-template #translateCell let-column="column">
            <div isEllipsisActive class="header-cell" [ngStyle]="{'background-color' : getColor(column.name)}"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'search-open' : ''">{{'columnName.'
                +
                column.name |
                translate}}</div>
            <div *ngIf="showSearch && !columnsNotToFilter.includes(column.name)" class="search-wrapper">
                <input
                    *ngIf="inputType(column.name).toLowerCase() !== 'boolean' && inputType(column.name).toLowerCase() !== 'timestamp' && inputType(column.name).toLowerCase() !== 'currency' && inputType(column.name).toLowerCase() !== 'number'"
                    max="2999-12-31" [type]="inputType(column.name).toLowerCase()" [ngModel]="column.searchValue"
                    class="form-control search-input"
                    [ngClass]="column.searchValue && column.searchValue.length > 0 ? 'has-value' : 'search-input-filter'"
                    [id]="column.name" (click)="$event.stopPropagation()"
                    (ngModelChange)="this.searchColumnUpdate.next({ value: $event, id: column.name })" />

                <input *ngIf="inputType(column.name).toLowerCase() === 'number'"
                    [type]="inputType(column.name).toLowerCase()" [ngModel]="column.searchValue"
                    class="form-control search-input"
                    [ngClass]="column.searchValue && column.searchValue.length > 0 ? 'has-value' : 'search-input-filter'"
                    [id]="column.name" (click)="$event.stopPropagation()"
                    (ngModelChange)="this.searchColumnUpdate.next({ value: $event, id: column.name })" />

                <input *ngIf="inputType(column.name).toLowerCase() === 'timestamp'" max="2999-12-31T00:00"
                    type="datetime-local" [ngModel]="column.searchValue" class="form-control search-input"
                    [ngClass]="column.searchValue && column.searchValue.length > 0 ? 'has-value' : 'search-input-filter'"
                    [id]="column.name" (click)="$event.stopPropagation()"
                    (ngModelChange)="this.searchColumnUpdate.next({ value: $event, id: column.name })" />

                <input *ngIf="inputType(column.name).toLowerCase() === 'currency'" [ngModel]="column.searchValue"
                    class="form-control search-input"
                    [ngClass]="column.searchValue && column.searchValue.length > 0 ? 'has-value' : 'search-input-filter'"
                    [id]="column.name" (click)="$event.stopPropagation()"
                    (ngModelChange)="this.searchColumnUpdate.next({ value: $event, id: column.name })" currencyMask
                    [options]="options" />

                <div *ngIf="inputType(column.name).toLowerCase() === 'boolean'" class="boolean-filter">
                    <div class="btn-group btn-group-toggle">
                        <label class="btn-secondary boolButton"
                            [ngClass]="column.searchValue === 'true' ? 'active' : ''" ngbButtonLabel
                            (click)="this.search('true', column.name)">
                            <input type="checkbox" ngbButton>True
                        </label>
                        <label class="btn-secondary boolButton"
                            [ngClass]="column.searchValue === 'false' ? 'active' : ''" ngbButtonLabel
                            (click)="this.search('false', column.name)">
                            <input type="checkbox" ngbButton> False
                        </label>
                    </div>
                </div>
                <div *ngIf="column.searchValue && column.searchValue.length > 0" class="clear-icon" aria-label="clear"
                    [inlineSVG]="'assets/ico/clear-button-red.svg'" (click)="clearSearchValue(column.name)"></div>
            </div>
        </ng-template>

        <ng-template #greenEyeIconHomepage let-row="row" let-value="value">
            <div *ngIf="!this.userWithOutPerm">
                <a [routerLink]="getRouteLink(row.personaIdentifier || row.persona_identifier, row.identifier)"
                    [state]="{from: route.snapshot.url[0] ? route.snapshot.url[0].path : ''}" class="greenEye"
                    [ngbTooltip]="greenEyeTooltip" tooltipClass="animation-tooltip-from-right" placement="left"
                    container="body" triggers="hover">
                    <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
                </a>
            </div>
        </ng-template>
        <ng-template #greenEyeIconAdmin let-row="row" let-value="value">
            <a [routerLink]="'details/' + row.identifier" class="greenEye" [ngbTooltip]="greenEyeTooltip"
                tooltipClass="animation-tooltip-from-right" placement="left" container="body" triggers="hover">
                <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
            </a>
        </ng-template>

    <ngx-datatable-footer>

        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
            let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
            <div class="page-count">
                {{rowCount}} total
            </div>
            <div class="footer_controls">
                <div class="dropdown_pageElements text-center" *ngIf="rowCount && rowCount > 0">
                    <select class="form-control custom_select" [(ngModel)]="pageElements" (change)="setPageSize($event)">
                        <option *ngFor="let pageElements of pageDropDown" [value]="pageElements">{{pageElements === 20000 ? 'All' : pageElements}}</option>
                    </select>
                </div>

                <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage"
                    [size]="pageSize" [count]="rowCount" [hidden]="!((rowCount / pageSize) > 1)"
                    (change)="setPage({count: page.totalElements, limit: pageElements, offset: $event.page - 1, pageSize: pageElements })">
                </datatable-pager>
            </div>
        </ng-template>
        
    </ngx-datatable-footer>

    </ngx-datatable>
</div>
